/* eslint-disable no-unused-vars */
import React from "react";

import { FormattedDate, FormattedTime } from "react-intl";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Typography from "@material-ui/core/Typography";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import highchartsMore from "highcharts/highcharts-more.js";

highchartsMore(Highcharts);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
    },
  })
);

interface VirtualInstrumentProps {
  // nodes: any[];
  data: any; // any[];
  widgetStatic?: boolean;
  widgetTitle?: string;
}

const VirtualInstrumentGauge = (props: VirtualInstrumentProps) => {
  const {
    // nodes,
    data,
    // widgetStatic
  } = props;
  const classes = useStyles(props);

  if (!data) {
    return <>No Data</>;
  }

  // function valueText(value: number) {
  //   return `${value}${data.unit}`;
  // }

  const gaugeOptions: any /*Highcharts.Options*/ = {
    chart: {
      type: "gauge",
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },

    title: {
      text: "",
    },

    pane: {
      startAngle: -150,
      endAngle: 150,
      background: [
        {
          backgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, "#FFF"],
              [1, "#333"],
            ],
          },
          borderWidth: 0,
          outerRadius: "109%",
        },
        {
          backgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, "#333"],
              [1, "#FFF"],
            ],
          },
          borderWidth: 1,
          outerRadius: "107%",
        },
        {
          // default background
        },
        {
          backgroundColor: "#DDD",
          borderWidth: 0,
          outerRadius: "105%",
          innerRadius: "103%",
        },
      ],
    },

    // the value axis
    yAxis: {
      min: data.min,
      max: data.max,

      minorTickInterval: "auto",
      minorTickWidth: 1,
      minorTickLength: 10,
      minorTickPosition: "inside",
      minorTickColor: "#666",

      tickPixelInterval: 30,
      tickWidth: 2,
      tickPosition: "inside",
      tickLength: 10,
      tickColor: "#666",
      labels: {
        step: 2,
        rotation: "auto",
      },
      title: {
        text: `${data.unit}`,
      },
      // plotBands: [{
      //     from: data.min,
      //     to: data.max,
      //     color: '#55BF3B' // green
      // }]
    },

    series: [
      {
        // name: 'Speed', // TODO data.name => node.displayName
        data: data.value ? [Number(data.value.toFixed(2))] : [],
        tooltip: {
          valueSuffix: ` ${data.unit}`,
        },
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <div className={classes.root}>
      <HighchartsReact
        containerProps={{ style: { height: "100%" } }}
        highcharts={Highcharts}
        // options={options}
        options={gaugeOptions}
      />
      {data.date && (
        <Typography variant="subtitle2">
          <FormattedDate
            value={data.date}
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
          &nbsp;
          <FormattedTime value={data.date} />
        </Typography>
      )}
    </div>
  );
};

export default VirtualInstrumentGauge;
